<mat-progress-bar *ngIf="loading" mode="indeterminate"></mat-progress-bar>
<div *ngIf="selectedPj">
  <h3>{{ selectedPj.value }}</h3>
  <h4>déposé le : {{ selectedPj.dt_created | date :'shortDate'}}</h4>
  <div fxLayout="colomn">
    <button mat-icon-button fxFlexAlign="center" (click)="prev()" *ngIf="hasPrev"><mat-icon >arrow_back</mat-icon></button>
    <app-preview-file [pj]="selectedPj" (onLoading)="onLoading($event)"></app-preview-file>
    <button *ngIf="hasNext" mat-icon-button fxFlexAlign="center" (click)="next()"><mat-icon >arrow_forward</mat-icon></button>
  </div>
</div>

<div mat-dialog-actions>
  <button mat-button (click)="close()">Fermer</button>
</div>
